import { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { MdAssignment } from "react-icons/md";
import "bootstrap/dist/css/bootstrap.min.css";
import TaskImage from "../../assets/images/Header/Task.png";
import milestoneImage from "../../assets/images/Header/MilestoneIcon.png";
import IssueImage from "../../assets/images/Header/issue image.png";
import { useFetchDashboardDetailsQuery, useFetchDashboardProjectDetailsQuery, useFetchPersonalSettingsQuery,} from "../../slice/logdetailSlice";
import Loader from "../common/Loader";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const DashboardCard = ({ data }) => {
  const {
    data: dashboard_details,
    isLoading: dashboard_loadding,
    refetch: dashboard_details_refetch,
  } = useFetchDashboardDetailsQuery();
  const {
    data: personal_details,
    refetch: user_detail_refetch,
  } = useFetchPersonalSettingsQuery();
  
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  //console.log("login_user in pproject:", login_user);
  // const { role: login_user_role } = login_user;
  // const { role: login_user_role } = login_user || {};
  // const {
  //   data: project_details,
  //   isError,
  //   isLoading: project_loadding,
  // } = 
  useFetchDashboardProjectDetailsQuery();
  // //console.log("project_details", project_details);
  // //console.log("dashboard_details", dashboard_details);

  // RTK Query automatically fetches on mount; redundant refetch on mount removed
  const navigate = useNavigate();
  const handleNavigate = (navigatePath) => {
    navigate(navigatePath);
  };
  return (
    <>
      {dashboard_loadding ? (
        <Loader />
      ) : (
        <div className="bg-white p-3 rounded-3 h-100 d-flex flex-column">
          <Typography variant="h6" sx={{ mb: 3 }}>
            👋 Welcome{" "}
            <span style={{ color: "#1abc9c", fontWeight: "bold", fontSize:"20px" }}>
              {" "}
              {dashboard_details?.user_name} !
            </span>
          </Typography>

          <div className="row text-center flex-grow-1">
            <div
              className="col-6 border-right py-3 d-flex align-items-center justify-content-center"
              onClick={() => handleNavigate("/projects")}
              style={{ cursor: "pointer" }}
            >

              <Box display="flex" alignItems="center" sx={{ width: "200px" }}>
                <span
                  className="rounded-circle me-3 d-flex align-items-center justify-content-center flex-shrink-0"
                  style={{ backgroundColor: "var(--header-bg-color)", width: "56px", height: "56px" }}
                >
                  <MdAssignment style={{ color: "rgb(15, 163, 141)", fontSize: "32px" }} />
                </span>

                <div className="d-flex flex-column align-items-start">
                  <p className="card-lable m-0 text-rgba-gray">
                    Active Projects
                  </p>
                  <Typography variant="h6" sx={{ mt: 0.5, fontWeight: "normal" }}>
                    {dashboard_details?.openProjects}
                  </Typography>
                </div>
              </Box>
            </div>

            <div
              className="col-6 py-3 d-flex align-items-center justify-content-center"
              style={{ cursor: "pointer" }}
              onClick={() => handleNavigate("/Tasks")}
            >
              <Box display="flex" alignItems="center" sx={{ width: "200px" }}>
                <span
                  className="rounded-circle me-3 d-flex align-items-center justify-content-center flex-shrink-0"
                  style={{ backgroundColor: "var(--header-bg-color)", width: "56px", height: "56px" }}
                >
                  <img src={TaskImage} alt="icon" style={{ width: "28px", height: "23px" }} />
                </span>
                <div className="d-flex flex-column align-items-start">
                  <p className="card-lable m-0 text-rgba-gray">Open Tasks</p>
                  <Typography variant="h6" sx={{ mt: 0.5, fontWeight: "normal" }}>
                    {dashboard_details?.openTasks}
                  </Typography>
                </div>
              </Box>
            </div>

            <div
              className="col-6 border-right border-top py-3 d-flex align-items-center justify-content-center"
              style={{ cursor: "pointer" }}
              onClick={() => handleNavigate("/Issues")}
            >
              <Box display="flex" alignItems="center" sx={{ width: "200px" }}>
                <span
                  className="rounded-circle me-3 d-flex align-items-center justify-content-center flex-shrink-0"
                  style={{ backgroundColor: "var(--header-bg-color)", width: "56px", height: "56px" }}
                >
                  <img src={IssueImage} alt="icon" style={{ width: "26px", height: "26px" }} />
                </span>
                <div className="d-flex flex-column align-items-start">
                  <p className="card-lable m-0 text-rgba-gray">Open Issues</p>
                  <Typography variant="h6" sx={{ mt: 0.5, fontWeight: "normal" }}>
                    {dashboard_details?.openIssues}
                  </Typography>
                </div>
              </Box>
            </div>
            
            <div
              className="col-6 border-top py-3 d-flex align-items-center justify-content-center"
              onClick={() => handleNavigate("/Milestones")}
              style={{ cursor: "pointer" }}
            >
              <Box display="flex" alignItems="center" sx={{ width: "200px" }}>
                <span
                  className="rounded-circle me-3 d-flex align-items-center justify-content-center flex-shrink-0"
                  style={{ backgroundColor: "var(--header-bg-color)", width: "56px", height: "56px" }}
                >
                  <img src={milestoneImage} alt="icon" style={{ width: "26px", height: "26px" }} />
                </span>
                <div className="d-flex flex-column align-items-start">
                  <p className="card-lable m-0 text-rgba-gray">Milestones</p>
                  <Typography variant="h6" sx={{ mt: 0.5, fontWeight: "normal" }}>
                    {dashboard_details?.openMilestones}
                  </Typography>
                </div>
              </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DashboardCard;
